import { alpha, darken } from '@mui/material/styles';

/**
 * The amber this app warns in.
 *
 * `palette.warning.main` is NOT amber in the PerfectRx theme -- it is the brand navy, which is
 * why `severity='warning'` and `color='warning'` both come out looking like information rather
 * than a warning. The amber lives on a non-standard key, `palette.warning.warningColour`, and
 * every existing warning in the app reaches for it the same way.
 *
 * The fallback is kept because the key is not part of the MUI palette contract: a theme that
 * does not define it still gets a colour rather than `undefined`.
 */
export const warningTone = (theme) =>
  theme.palette.warning.warningColour || theme.palette.warning.main;

/** The same amber as a wash, for a surface behind the text. */
export const warningTint = (theme, opacity) => alpha(warningTone(theme), opacity);

/**
 * The amber for WORDS, as opposed to icons and borders.
 *
 * The raw tone is bright enough to carry a 2px border or a 20px icon and still fail as small text
 * on the pale wash behind it. The single-item Fill Product panel makes the same distinction by
 * hand, keeping the bright amber for its icon and setting its captions several steps darker.
 * Derived from the one tone rather than written as a second hex, so a theme change moves both.
 */
export const warningTextTone = (theme) => darken(warningTone(theme), 0.45);

export default warningTone;
